<template>
  <v-card flat>
    <v-container>
      <v-form ref="form">
        <v-row dense no-gutters class="mb-2 mx-2">
          <v-col cols="12" md="4">
            <v-container>
              <v-row dense no-gutters>
                <v-col cols="12" class="mb-2">
                  <div class="title">{{ t("company.title") }}</div>
                </v-col>
                <v-col cols="12">
                  <sc-text-field
                    rule-required
                    :label="t('company.commercialName.label')"
                    :placeholder="t('company.commercialName.placeholder')"
                    :messages="t('company.commercialName.message')"
                    v-model="publicName"
                  ></sc-text-field>
                </v-col>
                <v-col cols="12">
                  <sc-text-field
                    :label="t('company.webPage.label')"
                    :placeholder="t('company.webPage.placeholder')"
                    :messages="t('company.webPage.message')"
                    v-model="website"
                  ></sc-text-field>
                </v-col>
                <v-col cols="12">
                  <sc-text-field
                    rule-required
                    rule-special-characters
                    :label="t('company.domain.label')"
                    :placeholder="t('company.domain.placeholder')"
                    :messages="domainMessage"
                    :error="domainUsedStatus === 'used'"
                    :loading="domainLoad"
                    v-model="domainCompleted"
                    suffix=".shuttlecentral.com"
                  >
                    <template v-slot:append>
                      <v-tooltip
                        content-class="pa-0 ma-0"
                        right
                        v-if="domainUsedStatus !== 'available'"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            color="primary"
                            class="material-icons-outlined mb-1"
                            >info</v-icon
                          >
                        </template>

                        <v-card class="black--text" max-width="250px">
                          <v-container class="text-center">
                            <div>{{ t("company.domain.help") }}</div>
                          </v-container>
                        </v-card>
                      </v-tooltip>
                    </template>
                  </sc-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col cols="12" md="4">
            <v-container>
              <v-row dense no-gutters>
                <v-col cols="12" class="mb-2">
                  <div class="title">{{ t("social.title") }}</div>
                </v-col>
                <v-col cols="12">
                  <sc-text-field
                    label="Twitter"
                    v-model="twitter"
                  ></sc-text-field>
                </v-col>
                <v-col cols="12">
                  <sc-text-field
                    label="Facebook"
                    v-model="facebook"
                  ></sc-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </v-card>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import debounce from "lodash/debounce";
export default {
  props: {
    defaultSubdomain: String,
  },
  computed: {
    ...mapFields("designer", [
      "model.domain",
      "model.settings.publicName",
      "model.settings.website",
      "model.settings.twitter",
      "model.settings.facebook",
    ]),
    domainMessage: (vm) =>
      vm.domainUsedStatus === null
        ? vm.t("company.domain.message")
        : vm.domainUsedStatus === "used"
        ? vm.t("company.domain.domainUsed")
        : vm.t("company.domain.domainAvailable"),
    domainCompleted: {
      get: (vm) => vm.subdomain,
      set(v) {
        this.subdomain = v.toLowerCase();
        this.domain = `${v.toLowerCase()}.shuttlecentral.com`;
      },
    },
  },
  data: () => ({
    subdomain: null,
    domainUsedStatus: null,
    domainLoad: false,
  }),
  mounted() {
    if (this.defaultSubdomain) {
      this.subdomain = this.defaultSubdomain;
      this.domainUsedStatus = "available";
    }
  },
  watch: {
    defaultSubdomain(v) {
      if (v) {
        this.subdomain = v;
        this.domainUsedStatus = "available";
      }
    },
    domain(v) {
      this.domainUsedStatus = null;
      this.debounce(v);
    },
  },
  methods: {
    debounce: debounce(function (v) {
      if (v) if (v.length > 0) this.validateDomain(v);
    }, 500),
    validate() {
      return (
        this.$refs.form.validate() && this.domainUsedStatus === "available"
      );
    },
    validateDomain(domain) {
      this.domainLoad = true;
      this.API.helpers
        .domainUsed({ domain })
        .then((response) => {
          this.domainUsedStatus =
            //Si el subdominio es igual al subdominio actual del cliente
            //entonces es un dominio DISPONIBLE para el
            this.defaultSubdomain === this.subdomain
              ? "available"
              : response === false
              ? "available"
              : "used";
        })
        .finally(() => (this.domainLoad = false));
    },
    t(key, options = {}) {
      return this.$t(`designer.companyData.${key}`, options);
    },
  },
};
</script>

<style></style>
